<template>
  <div class="fu-qcell" data-test="fu-cell-queue" :data-queue="cell.key">
    <span class="fu-qcell__icon" aria-hidden="true">
      <fu-icon v-if="opening" name="spin" :size="16" :stroke="2.4" class="fu-qcell__spin" label="Opening the follow-up panel" data-test="fu-opening" />
      <fu-icon v-else :name="cell.icon" :size="16" />
    </span>
    <button type="button" class="fu-qcell__label" data-test="fu-open-drawer" @click="$emit('open')">
      {{ cell.label }}
    </button>
    <span
      v-if="error"
      v-b-tooltip.hover.focus
      class="fu-qcell__error"
      tabindex="0"
      role="img"
      :title="errorText"
      :aria-label="errorText"
      data-test="fu-open-error"
    >
      <fu-icon name="alert" :size="16" />
    </span>
  </div>
</template>

<script>
/**
 * Patient Profile's first column (redesign Phase 5): the queue's icon and label — "Overdue
 * recall", "Outstanding claim"… (the export's `queue` cell). The label is a real button that opens
 * today's follow-up drawer for that row, the job the patient name does on the queue pages (every
 * profile row is the same patient). While the drawer opens the icon turns into the spinner, and a
 * failed open leaves the same error mark the patient cell shows.
 */
import FuIcon from './FuIcon.vue';

export default {
  name: 'FollowupsQueueCell',
  components: { FuIcon },
  props: {
    cell: { type: Object, required: true },   // rowModel buildProfileRow cells.queue: { key, label, icon }
    opening: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },
  computed: {
    errorText() {
      return 'Something went wrong while trying to make a follow-up attempt. Please try again in a moment.';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './mixins';

.fu-qcell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.fu-qcell__icon {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: $fu-brand-50;
  color: $fu-brand-700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
}

.fu-qcell__spin {
  @include fu-spin;
}

.fu-qcell__label {
  @include fu-button-reset;
  border-radius: $fu-radius-xs; // no `min-width: 0`: never narrower than its longest word
  text-align: left;
  font-weight: $fu-fw-bold;
  font-size: 14px;
  line-height: 1.3;
  color: $fu-brand-700;
  // Wrap at spaces (and the hyphen in "Pre-authorization") only — `anywhere` broke it mid-word
  // at 820 ("Pre-authoriza / tion"). The queue column's 140px minimum fits the longest word.
  overflow-wrap: normal;
  word-break: normal;
  hyphens: manual;
  &:hover { text-decoration: underline; }
  @include fu-focus-ring;
}

.fu-qcell__error {
  display: inline-flex;
  flex: none;
  color: $fu-danger;
  border-radius: 50%;
  @include fu-focus-ring;
}
</style>
